import React, { Component } from "react";

import UserTable from "./UserTable";

class UserPageLayout extends Component {
  render() {
    return (
      <UserTable />
    );
  }
}

export default UserPageLayout;
